export const getLayout = () => {
    switch (document.body.getAttribute('data-layout')) {
        case 'professionals':
            return 'professionals'
        default:
            return 'consumers'
    }
}
